import http from '../http';
import api from '../../config/SierraLeone/ke03-pregled-keno-listica.json';

export const pregledKenoListicaService = {
   get: (kolo, brojListica) => http.post(`${api.get}`, { kolo, brojListica })
};
